var exports = {
  "Qs": "x4ddf2309--47fa76--content",
  "qr": "x4ddf2309--47fa76--footer",
  "z3": "x4ddf2309--47fa76--error",
};

module.exports = exports;
